import styled from 'styled-components';
import { layoutSizes } from "../../../../constants/css";
export var OfferPointsDescription = styled.div.withConfig({
  displayName: "style__OfferPointsDescription",
  componentId: "sc-vvufbq-0"
})(["padding-bottom:30px;display:flex;justify-content:center;max-width:345px;@media only screen and (min-width:", "){max-width:100%;}"], layoutSizes.desktopWidth);
export var WWPartnerLogos = styled.img.withConfig({
  displayName: "style__WWPartnerLogos",
  componentId: "sc-vvufbq-1"
})(["width:225px;padding-bottom:50px;@media only screen and (min-width:", "){width:185px;}"], layoutSizes.desktopWidth);